// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"ed9cd886","472":"e9665560","524":"3eac39a9","572":"1ac3c49e","591":"6ca2bdcf","978":"2ef27060"}[chunkId] + ".chunk.js";
};